import { useEffect, useRef } from 'react';
import { captureException } from '@/modules/capture-exception';
import { markAuthReady } from '@/modules/sanr-api';
import { handleRestoreSession, trackSessionRestored } from './handlers';
import type { Profile } from '@/modules/sanr-api';

// A restore failure keeps the stored session for the next boot (a
// definitive 401 already tore it down through the expiry handler).
// markAuthReady() always flips so fetchApi unblocks.
export default function useRestoreInitialSession({
  setProfile,
  setIsAuthReady,
}: {
  setProfile: (profile: Profile) => void;
  setIsAuthReady: (ready: boolean) => void;
}) {
  const didInitRef = useRef(false);
  useEffect(() => {
    if (didInitRef.current) return;
    didInitRef.current = true;

    void (async () => {
      try {
        const restored = await handleRestoreSession();
        if (restored) {
          setProfile(restored);
          trackSessionRestored(restored);
        }
      } catch (e) {
        captureException(e);
      } finally {
        setIsAuthReady(true);
        markAuthReady();
      }
    })();
  }, [setProfile, setIsAuthReady]);
}
